var useLocal = false

import store from "@/store"
import cognito from "./cognito"

let baseURL = "https://29eqww07oe.execute-api.eu-west-2.amazonaws.com/live"

var headers = function (token) {
  return { "access-token": token }
}

import axios from "axios"

var initiallambda = axios.create({ baseURL: "/.netlify/functions/" })
function lambda() {
  return new Promise((resolve, reject) => {
    if (!store.state.customisations)
      store.subscribe((mutation) => {
        if (mutation.type == "setCustomisations") createLambda().then((res) => resolve(res))
      })
    else createLambda().then((res) => resolve(res))
  })
}

function createLambda() {
  return new Promise((resolve, reject) => {
    cognito.currentUserSession().then((userSession) => {
      resolve(
        axios.create({
          baseURL: "/.netlify/functions/",
          headers: headers(userSession.accessToken.jwtToken)
        })
      )
    })
  })
}

var website
store.subscribe((mutation) => {
  if (mutation.type == "setCustomisations") {
    website = axios.create({
      baseURL: window.location.hostname == "localhost" && useLocal ? "/" : store.state.customisations.site_url
    })
  }
})

const local = axios.create()

export default {
  headers: function () {
    return new Promise((resolve, reject) => {
      cognito.currentUserSession().then((userSession) => {
        resolve(headers(userSession.accessToken.jwtToken))
      })
    })
  },
  uploadURL: () => "/.netlify/functions/get-signed-url" + "?siteid=" + store.state.customisations.site_id,
  uploadCKURL: () => baseURL + "uploadCKImage" + "?siteid=" + store.state.customisations.site_id,
  cropImage: function (data, internal) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("crop-image" + "?siteid=" + store.state.customisations.site_id + (internal ? "&internal=1" : ""), data)
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    })
  },
  getCustomisations: function () {
    return new Promise((resolve, reject) => {
      initiallambda
        .post("customisations", { hostname: window.location.hostname })
        .then(function (response) {
          resolve(response.data.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getItems: function (type, ProjectionExpression, internal) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("get-items", { siteid: store.state.customisations.site_id, type, ProjectionExpression, internal })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  getUsers: function () {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("get-users", { siteid: store.state.customisations.site_id })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  deleteUser: function (user) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("delete-user", { siteid: store.state.customisations.site_id, username: user.username })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  createUser: function (user) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("create-user", { siteid: store.state.customisations.site_id, user })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  resetUserPassword: function (user) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("reset-user-password", { siteid: store.state.customisations.site_id, user })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  updateUser: function (user) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("update-user", { siteid: store.state.customisations.site_id, user })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  getPages: function (type, ProjectionExpression, internal) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("get-pages", { siteid: store.state.customisations.site_id, type, ProjectionExpression, internal })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  getSubPages: function (type, parent) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("get-sub-pages", { siteid: store.state.customisations.site_id, type, parent })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  getSubPagesDesc: function (type, parent) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("get-sub-pages", { siteid: store.state.customisations.site_id, type, parent, order: "desc" })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  getPagesDesc: function (type, ProjectionExpression, internal) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("get-pages", {
            siteid: store.state.customisations.site_id,
            type,
            order: "desc",
            ProjectionExpression,
            internal
          })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  getAllPages: function (type) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("all-pages", { siteid: store.state.customisations.site_id })
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    })
  },
  export: function (fields, itemtype, internal) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("export", { siteid: store.state.customisations.site_id, fields, itemtype, internal })
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    })
  },
  isDuplicateValue: function (itemtype, itemid, attribute, value) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("/is-duplicate", { itemtype, itemid, attribute, value, siteid: store.state.customisations.site_id })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  getPage: function (id, internal) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("get-page", { siteid: store.state.customisations.site_id, id, internal })
          .then((response) => resolve(response.data))
          .catch((error) => {
            reject(error)
          })
      })
    })
  },
  addPage: function (ItemType, OrderIndex, props, internal, shadowed_by) {
    return new Promise((resolve, reject) => {
      if (!ItemType) ItemType = "main"
      ItemType = "page." + ItemType
      lambda().then((request) => {
        request
          .post("update-page", {
            siteid: store.state.customisations.site_id,
            internal,
            page: Object.assign({ ItemType, OrderIndex }, props),
            shadowed_by
          })
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    })
  },
  duplicatePage: function (page, internal, shadowed_by) {
    return new Promise((resolve, reject) => {
      delete page.ItemID
      lambda().then((request) => {
        request
          .post("update-page", {
            siteid: store.state.customisations.site_id,
            internal,
            page,
            shadowed_by
          })
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    })
  },
  addSubItem: function (ItemType, OrderIndex, ParentID, props = {}, internal) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("update-page", {
            siteid: store.state.customisations.site_id,
            internal,
            page: Object.assign({ ItemType, OrderIndex, ParentID }, props)
          })
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    })
  },
  putPage: function (page, internal, shadowed_by) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("update-page", { siteid: store.state.customisations.site_id, internal, page, shadowed_by })
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    })
  },
  updatePage: function (page, internal) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("update-page-order-index", {
            siteid: store.state.customisations.site_id,
            page: {
              ItemID: page.ItemID,
              ItemType: page.ItemType,
              ParentID: page.ParentID,
              OrderIndex: page.OrderIndex
            },
            internal
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    })
  },
  deletePage: function (page, internal, shadowed_by) {
    return new Promise((resolve, reject) => {
      lambda().then((request) => {
        request
          .post("delete-page", { siteid: store.state.customisations.site_id, internal, page, shadowed_by })
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    })
  },
  geocode: function (address) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          "https://maps.googleapis.com/maps/api/geocode/json?address=" +
            encodeURIComponent(address) +
            "&key=AIzaSyBKCUxnqyzcUY92lydH_9IphBKn-hKL4wA"
        )
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  getSchema: function (type) {
    return getSchema(type)
  },
  getSpecificSchema: function (type) {
    return getSchema(type, true)
  }
}

function getSchema(type, specific = false) {
  return new Promise((resolve, reject) => {
    var schema = store.getters["schemas/getSchema"](type)

    if (schema && Object.keys(schema).length === 0 && schema.constructor === Object) reject()
    else if (schema) resolve(schema)
    else
      website
        .get("schemas/" + type + ".schema.json")
        .then((response) => {
          var schema = response.data

          var promises = []
          if (schema.items)
            if (schema.items.merge_with)
              promises.push(
                getSchema(schema.items.merge_with).then((mergeschema) => {
                  schema.item = mergeschema.item.concat(schema.item)
                })
              )

          Promise.all(promises).then(() => {
            store.commit("schemas/ADD_SCHEMA", { name: type, schema })
            resolve(schema)
          })
        })
        .catch(() => {
          if (!specific) {
            if (type != "page.main")
              getSchema("page.main").then((schema) => {
                store.commit("schemas/ADD_SCHEMA", { name: type, schema })
                resolve(schema)
              })
          } else {
            store.commit("schemas/ADD_SCHEMA", { name: type, schema: {} })
            reject()
          }
        })
  })
}
